/**
 * Logo Victor · vrai logotype (PNG haute résolution).
 * Wordmark "victor" en SwileNova Black, lowercase.
 */
type LogoProps = {
  size?: number;
  withWordmark?: boolean;
  className?: string;
};

export function Logo({ size = 36, withWordmark = false, className }: LogoProps) {
  return (
    <span
      className={className}
      style={{ display: "inline-flex", alignItems: "center", gap: 10 }}
    >
      <img
        src="/brand/logotype.png"
        alt={withWordmark ? "" : "Victor"}
        aria-hidden={withWordmark ? "true" : undefined}
        width={size}
        height={size}
        style={{ display: "block" }}
      />
      {withWordmark ? (
        <span
          style={{
            fontFamily: "var(--font-display)",
            fontWeight: 900,
            fontSize: size * 0.62,
            letterSpacing: "-0.04em",
            color: "var(--color-navy-800)",
            lineHeight: 1,
          }}
        >
          victor
        </span>
      ) : null}
    </span>
  );
}
